<template>
    <div class="footer_7 ">
		<div class="fixed footer_8">
			<div class="w1200 flex benben-flex-layout align-center footer ">
				<img class="footer_1 pointer" src="https://api.ezlunch.club/pc/image/3.png" alt="" srcset="" @click="qiehuan(1,1)">
				<div class="footer_2">{{$t('专业外卖平台')}}</div>
				
				<div class="flex flex-wrap align-center justify-around benben-flex-layout flex-sub kuandu" v-if="tab_id == 1 || tab_id == 2 ||tab_id == 3">
					
					<div class="flex flex-direction flex-wrap align-center benben-flex-layout pointer footer_5" @click="qiehuan(1,1)">
						<div class="footer_5_1">Menu</div>
						<div :class="tab_id == 1 ? 'footer_5_2' : 'footer_5_3'  "></div>
					</div>
					<div class="flex flex-direction flex-wrap align-center benben-flex-layout pointer footer_5" @click="qiehuan(1,2)">
						<div class="footer_5_1">Photos</div>
						<div :class="tab_id == 2 ? 'footer_5_2' : 'footer_5_3'  "></div>
					</div>
					<div class="flex flex-direction flex-wrap align-center benben-flex-layout pointer footer_5" @click="qiehuan(1,3)">
						<div class="footer_5_1">{{$t('客服二维码')}}</div>
						<div :class="tab_id == 3 ? 'footer_5_2' : 'footer_5_3'  "></div>
					</div>
					<div class="flex flex-direction flex-wrap align-center benben-flex-layout pointer footer_5" @click="qiehuan(1,4)">
						<div class="footer_5_1">{{$t('点单界面')}}</div>
						<div :class="tab_id == 4 ? 'footer_5_2' : 'footer_5_3'  "></div>
					</div>
					
				</div>
				<div class="flex flex-wrap align-center justify-around benben-flex-layout flex-sub kuandu" v-else>
					<div class="flex flex-direction flex-wrap align-center benben-flex-layout pointer footer_5" @click="qiehuan(1,4)">
						<div class="footer_5_1">{{$t('点单界面')}}</div>
						<div :class="tab_id == 4 ? 'footer_5_2' : 'footer_5_3'  "></div>
					</div>
					<div class="flex flex-direction flex-wrap align-center benben-flex-layout pointer footer_5" @click="qiehuan(1,5)">
						<div class="footer_5_1">{{$t('个人主页')}}</div>
						<div :class="tab_id == 8 ? 'footer_5_2' : 'footer_5_3'  "></div>
					</div>
				</div>
				
				
				<div class="pointer footer_3" v-if="!token" @click="qiehuan(1,7)">{{$t('登录')}}</div>
				<div class="flex benben-flex-layout  align-center footer_4" v-else>
					<div class="relative footer_4_1 pointer" @click="qiehuan(1,6)">
						<img class="footer_4_2" src="https://api.ezlunch.club/pc/image/14.png" alt="" srcset="">
						<div class="absolute footer_4_3" v-if="allnum > 0">{{allnum}}</div>
					</div>
					<div class="footer_4_4 pointer" @click="qiehuan(1,5)">ID:{{user.number}}</div>
					<el-popconfirm
					  :title="$t('确定要退出么？')"
					  :confirm-button-text="$t('确定')"
					  :cancel-button-text="$t('取消')"
					  @confirm="queding"
					>
					  <el-button slot="reference" class="foot_5">
						  <div class="footer_4_5 pointer">{{$t('退出')}}</div>
					  </el-button>
					</el-popconfirm>
					
				</div>
				<div class="flex benben-flex-layout flex-wrap align-center pointer login_2_1" @click="qiehuan(2)">
					<img class="login_2_11" src="https://api.ezlunch.club/pc/image/2.png" alt="" srcset="">
					<div class="">{{ $t('语言切换') }}</div>
				</div>
			</div>
		</div>
		<el-dialog class="footer_6" title="" :visible.sync="dialogVisible" width="454px" >
			<div class="flex flex-direction flex-wrap align-center benben-flex-layout footer_6_1">
				<div class="footer_6_4">{{$t('切换语言')}}</div>
				<div class="pointer" @click="qiehuan(3,'zh')" :class="lale == 'zh' ? 'footer_6_3' : 'footer_6_2'">{{$t('简体中文')}}</div>
				<div class="pointer" @click="qiehuan(3,'en')" :class="lale == 'en' ? 'footer_6_3' : 'footer_6_2'">{{$t('英文')}}</div>
				<div class="pointer footer_6_5" @click="qiehuan(4)">{{$t('确定')}}</div>
			</div>
		</el-dialog>
		
    </div>
</template>

<script>
  export default {
    name: 'nav-footer',
    data(){
        return{
		    tab_list:[
			    {name:'menu',url:'',aid:'1'},
			    {name:'photos',url:'',aid:'2'},
			    {name:'客服二维码',url:'',aid:'3'},
			    {name:'点单界面',url:'',aid:'4'},
		    ],
			tab_id:1,
		    token:'',
			dialogVisible:false,
			lale:'',
			user:'',
			allnum:'',
			path_url :''
	    }
    },
	watch: {
	        //监听路由地址的改变
	        $route:{
	            immediate:true,
	            handler(){
		            if(this.$route.path == '/menu'){
						this.tab_id = 1
					}else if(this.$route.path == '/photos'){
						this.tab_id = 2
					}else if(this.$route.path == '/codeQr'){
						this.tab_id = 3
					}else if(this.$route.path == '/orderFood'){
						this.tab_id = 4
					}else{
						this.tab_id = 8
					}
		            // console.log(this.$route.path,'123路由变化')
					this.path_url = this.$route.path
	            }
	        }
	},
    mounted() {
    },
	created(){
		// if (window.sessionStorage.getItem('statusType')) {
		// 	this.tab_id = window.sessionStorage.getItem('statusType')
		// }
		if(window.sessionStorage.getItem('token')){
			this.token = window.sessionStorage.getItem('token')
		}else{
			this.token = ''
			this.user = ''
		}
		// console.log(this.token,1111111)
		this.post5c78c4772da97()
		this.post64241ca6cf066()
	},
    methods: {
		// 消息角标
		post64241ca6cf066(){
			if(this.token){
				this.$api.post(this.$apiUrls.post64241ca6cf066).then((res) => {
					if(res.code == 1){
						this.allnum = res.data.all
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			}
		},
		// 个人资料
		post5c78c4772da97(){
			if(this.token){
				this.$api.post(this.$apiUrls.post5c78c4772da97).then((res) => {
					if(res.code == 1){
						this.user = res.data
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			}
		},
		qiehuan(type,item){
			if(type == 1){
				if(this.tab_id == item){
					return
				}
				this.tab_id = item
				let url = ''
				if(item == 1){
					url = 'menu'
				}else if(item == 2){
					url = 'photos'
				} else if(item == 3){
					url = 'codeQr'
				} else if(item == 4){
					url = 'orderFood'
				} else if(item == 5){
					// if (window.sessionStorage.getItem('menr_type') && window.sessionStorage.getItem('menr_type') == 1) {
					// 	return
					// }
					url = 'myinfo'
					window.sessionStorage.setItem('menr_type', 1);
				} else if(item == 6){
					url = 'myNew'
				} else if(item == 7){
					url = 'login'
				}
				
				window.sessionStorage.setItem('statusType', item);
				this.$router.push({
					name: url,
				});
			}else if(type == 2){
				this.lale = this.$i18n.locale
				
				this.dialogVisible = true
			}else if(type == 3){
				this.lale = item
			}else if(type == 4){
				this.$i18n.locale = this.lale
				window.sessionStorage.setItem('locale', this.lale);
				this.dialogVisible = false
				this.$emit("qiehuan");
				// console.log(window.sessionStorage.getItem('locale'),'语言包')
				
			}
			
		},
		queding(){
			this.token = ''
			this.user = ''
			window.sessionStorage.setItem('address_id','');
			window.sessionStorage.setItem('order_type','');
			window.sessionStorage.setItem('order_id', '');
			window.sessionStorage.setItem('token', '');
			window.sessionStorage.setItem('user','');
			window.sessionStorage.setItem('statusType', '');
			window.sessionStorage.setItem('can_type', '');
			window.sessionStorage.setItem('payItem','');
			if(this.path_url != '/menu'){
				this.$router.replace({
					name: 'menu',
				});
			}
		}
	}
  }
</script>

<style lang="scss" scoped>
	::v-deep {
		.foot_5{
			padding: 0;
			margin: 0;
			border: none;
		}
		.foot_5 span{
			display: flex;
		}
		.foot_5:hover {
			background: #fff;
		}
		.footer_6{
			.el-dialog__header{
				display: none;
			}
			.el-dialog__body{
				padding: 0 !important;
				border-radius: 16px 16px 16px 16px;
				// background: rgba(187,195,211,0) !important;
			}
		}
		
	}
	.footer_7{
		width: 100%;
		height: 72px;
		background: #fff;
	}
	.footer_8{
		width: 100%;
		height: 72px;
		background: #fff;
		left: 50%;
		transform: translateX(-50%);
		z-index: 10;
	}
	.footer{
		height: 72px;
		
	}
	.footer_1{
		width: 109px;
		height: 34px;
	}
	.footer_2{
		width: 150px;
		font-weight: bold;
		font-size: 16px;
		color: #1A1A1A;
		margin: 0 0 0 16px;
	}
	.footer_3{
		font-weight: bold;
		font-size: 16px;
		color: #1A1A1A;
		margin: 0 0 0 auto;
	}
	.login_2_1{
		background: #FF770F;
		border-radius: 8px 8px 8px 8px;
		margin: 0 0 0 18px;
		padding: 8px 16px;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
	}
	.login_2_11{
		width: 16px;
		height: 16px;
		margin-right: 10px;
	}
	.footer_4{
		margin: 0 0 0 auto;
	}
	.footer_4_1{
		width: 48px;
		height: 48px;
	}
	.footer_4_2{
		width: 48px;
		height: 48px;
	}
	.footer_4_3{
		background: #FF4B4D;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
		border-radius: 100px;
		top: -6px;
		right: 0;
		width: 20px;
		height: 20px;
		text-align: center;
	}
	.footer_4_4{
		font-weight: bold;
		font-size: 14px;
		color: #1A1A1A;
		margin: 0 0 0 20px;
	}
	.footer_4_5{
		font-weight: 400;
		font-size: 14px;
		color: #666666;
		margin: 0 0 0 14px;
	}
	.footer_5{
		// margin: 0 30px;
	}
	.footer_5_1{
		font-weight: 400;
		font-size: 16px;
		color: #666666;
	}
	.footer_5_2{
		width: 30px;
		height: 2px;
		background: #333333;
		border-radius: 0px 0px 0px 0px;
	}
	.footer_5_3{
		width: 30px;
		height: 2px;
		background: #fff;
		border-radius: 0px 0px 0px 0px;
	}
	.footer_6_1{
		width: 454px;
		height: 436px;
		background: #fff;
		box-shadow: 0px 7px 18px 1px rgba(187,195,211,0.41);
		border-radius: 16px 16px 16px 16px;
	}
	.footer_6_2{
		width: 260px;
		height: 72px;
		background: #F0F0F0;
		border: 1px solid #F0F0F0;
		border-radius: 12px 12px 12px 12px;
		text-align: center;
		line-height: 72px;
		margin: 0 0 24px 0;
		font-weight: 500;
		font-size: 16px;
		color: #333333;
	}
	.footer_6_3{
		width: 260px;
		height: 72px;
		background: #fff;
		border: 1px solid #FF8A24;
		border-radius: 12px 12px 12px 12px;
		text-align: center;
		line-height: 72px;
		margin: 0 0 24px 0;
		font-weight: 500;
		font-size: 16px;
		color: #FF8A24;
	}
	.footer_6_4{
		font-weight: bold;
		font-size: 20px;
		color: #1A1A1A;
		margin: 48px 0 40px;
	}
	.footer_6_5{
		width: 260px;
		height: 48px;
		background: #FF770F;
		border-radius: 8px 8px 8px 8px;
		text-align: center;
		line-height: 48px;
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
		margin: 20px 0 0 0;
	}
	.kuandu{
		min-width: 400px;
	}
</style>